import { useNavigate } from "react-router-dom";

import TransferService from "../../services/TransferBetweenWarehouses";

import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader";

const TransfertsByWarehouseManager = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [showElement, setShowElement] = useState([]);

  const [statusValue, setStatusValue] = useState("Toutes les status");
  const [startDate, setStartDate] = useState("any");
  const [endDate, setEndDate] = useState("any");
  const [
    currentWarehouseManagerTransfertsForSourceWarehouse,
    setCurrentWarehouseManagerTransfertsForSourceWarehouse,
  ] = useState(null);

  const [
    currentWarehouseManagerTransfertsForDestinationWarehouse,
    setCurrentWarehouseManagerTransfertsForDestinationWarehouse,
  ] = useState(null);

  useEffect(() => {
    if (startDate === ":59") {
      setStartDate("any");
    }
    if (endDate === ":59") {
      setEndDate("any");
    }
  }, [startDate, endDate]);
  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, []);
  useEffect(() => {
    startLoading();

    TransferService.getWarehouseTransfertByWarhouseManager(
      "source",
      "any",
      "any",
      "Toutes les status"
    )
      .then((response) => {
        console.log("response transfert", response);
        if (Object.keys(response.data)[0] === "success") {
          setCurrentWarehouseManagerTransfertsForSourceWarehouse(
            response.data.success
          );
        }
      })
      .catch((error) => {
        console.log("error : ", error);
      });

    TransferService.getWarehouseTransfertByWarhouseManager(
      "destination",
      "any",
      "any",
      "Toutes les status"
    )
      .then((response) => {
        if (response.data.success) {
          setCurrentWarehouseManagerTransfertsForDestinationWarehouse(
            response.data.success
          );
        }
      })
      .catch((error) => {
        console.log("error : ", error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const onViewProductsHandler = (refTransfert) => {
    sessionStorage.setItem("refTransfert", refTransfert);
    // navigate("/informationsTransfert");
    window.open("/informationsTransfert", "_blank");
  };

  const onChangeStatusHandlder = (e) => {
    setStatusValue(e.target.value);
  };

  const onChangeStartDate = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value already includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // If time exists, append ":00" to set seconds to 00
      : selectedValue + "T00:00:00"; // If it's a date-only input, append "T00:00:00" for the first second of the day

    setStartDate(updatedValue);
  };

  const onChangeEndDate = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value already includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59" // If time exists, append ":59" to set seconds to 59
      : selectedValue + "T23:59:59"; // If it's a date-only input, append "T23:59:59" for the last second of the day

    setEndDate(updatedValue);
  };


  const onGetTransfertsByFilterHandler = () => {
    console.log(endDate);
    console.log(startDate);
    console.log(statusValue);

    startLoading();
    TransferService.getWarehouseTransfertByWarhouseManager(
      "source",
      startDate,
      endDate,
      statusValue
    )
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          setCurrentWarehouseManagerTransfertsForSourceWarehouse(
            response.data.success
          );
        }
      })
      .catch((error) => {
        console.log("error :" + error);
      });

    TransferService.getWarehouseTransfertByWarhouseManager(
      "destination",
      startDate,
      endDate,
      statusValue
    )
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          setCurrentWarehouseManagerTransfertsForDestinationWarehouse(
            response.data.success
          );
        }
      })
      .catch((error) => {
        console.log("error :" + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onAddTransfertHandler = () => {
    navigate(`/warehouseTransfert`);
  };
  const onAddTransfertAdminHandler = () => {
    navigate(`/warehouseTransfertAdmin`);
  };
  const onAddTransfertExcelHandler = () => {
    navigate(`/warehouseTransfertExcel`);
  };
  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
  const dateToInput = (value) => (value === "any" ? "" : value.split("T")[0]);
  const onResetFilters = () => {
    setStatusValue("Toutes les status");
    setStartDate("any");
    setEndDate("any");
  };

  const stateBadge = (state) => {
    if (state === "toDo")
      return <span className="badge badge-warning">à confirmer</span>;
    if (state === "doing")
      return <span className="badge badge-light border">confirmé</span>;
    if (state === "doingSource")
      return <span className="badge badge-dark">en cours</span>;
    return <span className="badge badge-success">terminée</span>;
  };

  const renderTransfersCard = (title, icon, transfers) => (
    <div className="card card-outline card-dark mb-4" style={cardStyle}>
      <div className="card-header">
        <h3 className="card-title">
          <i className={`${icon} mr-2`}></i>
          {title}
          <span className="badge badge-dark ml-2">
            {transfers ? transfers.length : 0}
          </span>
        </h3>
        <div className="card-tools">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="collapse"
            title="Réduire"
          >
            <i className="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <div className="card-body p-0 table-responsive">
        <table className="table table-hover table-striped mb-0">
          <thead className="thead-light">
            <tr className="text-center">
              <th>Référence</th>
              <th>Source</th>
              <th>Destination</th>
              <th>Date de création</th>
              <th>Date limite</th>
              <th>État</th>
              <th>Info</th>
            </tr>
          </thead>
          <tbody>
            {(!transfers || transfers.length === 0) && (
              <tr>
                <td colSpan={7} className="text-center text-muted py-4">
                  <i className="fas fa-exchange-alt fa-2x mb-2 d-block"></i>
                  Aucun transfert trouvé
                </td>
              </tr>
            )}
            {transfers &&
              transfers.map((element) => (
                <tr key={element.id} className="text-center">
                  <td>
                    <span className="badge badge-light border">
                      {element.reference}
                    </span>
                  </td>
                  <td>{element.warehouseSourceName}</td>
                  <td>{element.warehouseDestinationName}</td>
                  <td>{element.creation_date}</td>
                  <td>{element.deadline}</td>
                  <td>{stateBadge(element.state)}</td>
                  <td>
                    <button
                      type="button"
                      title="Voir les produits du transfert"
                      className="btn btn-sm btn-outline-dark"
                      style={{ width: 36 }}
                      onClick={() => onViewProductsHandler(element.reference)}
                    >
                      <i className="fas fa-shopping-cart"></i>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-exchange-alt mr-2"></i>Les transferts
              </h4>
              <small className="text-muted">
                Suivez les transferts demandés et à accepter
              </small>
            </div>
            <div className="mt-2 mt-sm-0">
              <button
                className="btn btn-outline-dark mr-2"
                onClick={() => navigate("/rfidTransfert")}
              >
                <i className="fas fa-broadcast-tower mr-1"></i>
                Transfert RFID
              </button>
              <button
                className="btn btn-outline-dark mr-2"
                onClick={onAddTransfertExcelHandler}
              >
                <i className="fas fa-file-excel mr-1"></i>
                Transfert via Excel
              </button>
              {showElement.includes("WAREHOUSE_MANAGER") && (
                <button className="btn btn-dark" onClick={onAddTransfertHandler}>
                  <i className="fas fa-plus mr-1"></i>
                  Transfert par produit
                </button>
              )}
              {showElement.includes("ADMIN") && (
                <button
                  className="btn btn-dark ml-2"
                  onClick={onAddTransfertAdminHandler}
                >
                  <i className="fas fa-plus mr-1"></i>
                  Transfert par produit
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="card card-outline card-dark" style={cardStyle}>
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-filter mr-2"></i>Filtres
              </h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="transferStatus" style={labelStyle}>
                      Statut
                    </label>
                    <select
                      id="transferStatus"
                      value={statusValue}
                      onChange={onChangeStatusHandlder}
                      className="form-control"
                    >
                      <option value={"Toutes les status"}>
                        Toutes les status
                      </option>
                      <option value={"Confirmé"}>Confirmé</option>
                      <option value={"Terminé"}>Terminé</option>
                      <option value={"En cours"}>En cours</option>
                      <option value={"à confirmé"}>à confirmé</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="transferStart" style={labelStyle}>
                      Date début
                    </label>
                    <input
                      id="transferStart"
                      type="date"
                      className="form-control"
                      value={dateToInput(startDate)}
                      onChange={onChangeStartDate}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="transferEnd" style={labelStyle}>
                      Date fin
                    </label>
                    <input
                      id="transferEnd"
                      type="date"
                      className="form-control"
                      value={dateToInput(endDate)}
                      onChange={onChangeEndDate}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-right">
              <button
                className="btn btn-outline-secondary mr-2"
                onClick={onResetFilters}
              >
                <i className="fas fa-undo mr-1"></i>
                Réinitialiser
              </button>
              <button
                className="btn btn-dark"
                onClick={onGetTransfertsByFilterHandler}
              >
                <i className="fas fa-search mr-1"></i>
                Valider le choix
              </button>
            </div>
          </div>

          {renderTransfersCard(
            "Les transferts demandés",
            "fas fa-inbox",
            currentWarehouseManagerTransfertsForDestinationWarehouse
          )}
          {renderTransfersCard(
            "Les transferts à accepter",
            "fas fa-paper-plane",
            currentWarehouseManagerTransfertsForSourceWarehouse
          )}
        </div>
      </section>
    </div>
  );
};
export default withLoader(TransfertsByWarehouseManager);
